import {
    LC_PROFORMA_INVOICE_LIST_REQUEST,
    LC_PROFORMA_INVOICE_LIST_SUCCESS,
    LC_PROFORMA_INVOICE_LIST_FAIL,
    LC_PROFORMA_INVOICE_DETAILS_REQUEST,
    LC_PROFORMA_INVOICE_DETAILS_SUCCESS,
    LC_PROFORMA_INVOICE_DETAILS_FAIL,
    LC_PROFORMA_INVOICE_CREATE_REQUEST,
    LC_PROFORMA_INVOICE_CREATE_SUCCESS,
    LC_PROFORMA_INVOICE_CREATE_FAIL,
    LC_PROFORMA_INVOICE_UPDATE_REQUEST,
    LC_PROFORMA_INVOICE_UPDATE_SUCCESS,
    LC_PROFORMA_INVOICE_UPDATE_FAIL,
    LC_PROFORMA_INVOICE_UPDATE_RESET,
    LC_PROFORMA_INVOICE_DELETE_REQUEST,
    LC_PROFORMA_INVOICE_DELETE_SUCCESS,
    LC_PROFORMA_INVOICE_DELETE_FAIL,
    LC_LIFECYCLE_LIST_REQUEST,
    LC_LIFECYCLE_LIST_SUCCESS,
    LC_LIFECYCLE_LIST_FAIL,
    LC_PAYMENT_TERMS_LIST_REQUEST,
    LC_PAYMENT_TERMS_LIST_SUCCESS,
    LC_PAYMENT_TERMS_LIST_FAIL,
    LC_DOCUMENT_LIST_REQUEST,
    LC_DOCUMENT_LIST_SUCCESS,
    LC_DOCUMENT_LIST_FAIL,
    LC_DOCUMENT_DETAILS_REQUEST,
    LC_DOCUMENT_DETAILS_SUCCESS,
    LC_DOCUMENT_DETAILS_FAIL,
    LC_DOCUMENT_CREATE_REQUEST,
    LC_DOCUMENT_CREATE_SUCCESS,
    LC_DOCUMENT_CREATE_FAIL,
    LC_DOCUMENT_UPDATE_REQUEST,
    LC_DOCUMENT_UPDATE_SUCCESS,
    LC_DOCUMENT_UPDATE_FAIL,
    LC_DOCUMENT_DELETE_REQUEST,
    LC_DOCUMENT_DELETE_SUCCESS,
    LC_DOCUMENT_DELETE_FAIL,
    LC_PROFORMA_INVOICE_ESCALATE_REQUEST,
    LC_PROFORMA_INVOICE_ESCALATE_SUCCESS,
    LC_PROFORMA_INVOICE_ESCALATE_FAIL,
    LC_PROFORMA_INVOICE_ESCALATE_RESET,
    LC_GET_LIST_BY_STATUS_REQUEST,
    LC_GET_LIST_BY_STATUS_SUCCESS,
    LC_GET_LIST_BY_STATUS_FAIL,

    PI_NUMBER_LIST_REQUEST,
    PI_NUMBER_LIST_SUCCESS,
    PI_NUMBER_LIST_FAIL,

    PI_CONDITIONS_UPDATE_REQUEST,
    PI_CONDITIONS_UPDATE_SUCCESS,
    PI_CONDITIONS_UPDATE_FAIL,

    UPDATE_CUSTOMIZED_CHECKBOXES,
    RESET_CUSTOMIZED_CHECKBOXES,
  
  } from "../constants/LcConstans";
  
  // Proforma Invoice List Reducer
  export const proformaInvoiceListReducer = (state = { proformaInvoices: [] }, action) => {
    switch (action.type) {
      case LC_PROFORMA_INVOICE_LIST_REQUEST:
        return { loading: true };
      case LC_PROFORMA_INVOICE_LIST_SUCCESS:
        return { loading: false, proformaInvoices: action.payload };
      case LC_PROFORMA_INVOICE_LIST_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  // Proforma Invoice Details Reducer
  export const proformaInvoiceDetailsReducer = (state = { proformaInvoice: null, loadingPiDetails: false, errorPiDetails: null }, action) => {
    switch (action.type) {
      case LC_PROFORMA_INVOICE_DETAILS_REQUEST:
        return { ...state, loadingPiDetails: true, errorPiDetails: null };
      case LC_PROFORMA_INVOICE_DETAILS_SUCCESS:
        return { loadingPiDetails: false, proformaInvoice: action.payload, errorPiDetails: null };
      case LC_PROFORMA_INVOICE_DETAILS_FAIL:
        return { loadingPiDetails: false, errorPiDetails: action.payload, proformaInvoice: null };
      default:
        return state;
    }
  };
  
  
  // Proforma Invoice Create Reducer
  export const proformaInvoiceCreateReducer = (state = {}, action) => {
    switch (action.type) {
      case LC_PROFORMA_INVOICE_CREATE_REQUEST:
        return { loading: true };
      case LC_PROFORMA_INVOICE_CREATE_SUCCESS:
        return { loading: false, success: true, proformaInvoice: action.payload };
      case LC_PROFORMA_INVOICE_CREATE_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  // Proforma Invoice Update Reducer
  export const proformaInvoiceUpdateReducer = (state = {}, action) => {
    switch (action.type) {
      case LC_PROFORMA_INVOICE_UPDATE_REQUEST:
        return { loading: true };
      case LC_PROFORMA_INVOICE_UPDATE_SUCCESS:
        return { loading: false, success: true, updatedData: action.payload }; // ✅ Save updated data
      case LC_PROFORMA_INVOICE_UPDATE_FAIL:
        return { loading: false, error: action.payload };
      case LC_PROFORMA_INVOICE_UPDATE_RESET:
        return {}; // ✅ Reset state after an update
      default:
        return state;
    }
  };
  
  
  // Proforma Invoice Delete Reducer
  export const proformaInvoiceDeleteReducer = (state = {}, action) => {
    switch (action.type) {
      case LC_PROFORMA_INVOICE_DELETE_REQUEST:
        return { loading: true };
      case LC_PROFORMA_INVOICE_DELETE_SUCCESS:
        return { loading: false, success: true };
      case LC_PROFORMA_INVOICE_DELETE_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  // LC Lifecycle List Reducer
  export const lifecycleListReducer = (state = { lifecycles: [] }, action) => {
    switch (action.type) {
      case LC_LIFECYCLE_LIST_REQUEST:
        return { loading: true };
      case LC_LIFECYCLE_LIST_SUCCESS:
        return { loading: false, lifecycles: action.payload };
      case LC_LIFECYCLE_LIST_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  // LC Payment Terms List Reducer
  export const paymentTermsListReducer = (state = { paymentTerms: [] }, action) => {
    switch (action.type) {
      case LC_PAYMENT_TERMS_LIST_REQUEST:
        return { loading: true };
      case LC_PAYMENT_TERMS_LIST_SUCCESS:
        return { loading: false, paymentTerms: action.payload };
      case LC_PAYMENT_TERMS_LIST_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  // Document List Reducer
  export const documentListReducer = (state = { documents: [] }, action) => {
    switch (action.type) {
      case LC_DOCUMENT_LIST_REQUEST:
        return { loading: true };
      case LC_DOCUMENT_LIST_SUCCESS:
        return { loading: false, documents: action.payload };
      case LC_DOCUMENT_LIST_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  // Document Details Reducer
  export const documentDetailsReducer = (state = { document: {} }, action) => {
    switch (action.type) {
      case LC_DOCUMENT_DETAILS_REQUEST:
        return { loading: true, ...state };
      case LC_DOCUMENT_DETAILS_SUCCESS:
        return { loading: false, document: action.payload };
      case LC_DOCUMENT_DETAILS_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  // Document Create Reducer
  export const documentCreateReducer = (state = {}, action) => {
    switch (action.type) {
      case LC_DOCUMENT_CREATE_REQUEST:
        return { loading: true };
      case LC_DOCUMENT_CREATE_SUCCESS:
        return { loading: false, success: true, document: action.payload };
      case LC_DOCUMENT_CREATE_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  // Document Update Reducer
  export const documentUpdateReducer = (state = {}, action) => {
    switch (action.type) {
      case LC_DOCUMENT_UPDATE_REQUEST:
        return { loading: true };
      case LC_DOCUMENT_UPDATE_SUCCESS:
        return { loading: false, success: true };
      case LC_DOCUMENT_UPDATE_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  // Document Delete Reducer
  export const documentDeleteReducer = (state = {}, action) => {
    switch (action.type) {
      case LC_DOCUMENT_DELETE_REQUEST:
        return { loading: true };
      case LC_DOCUMENT_DELETE_SUCCESS:
        return { loading: false, success: true };
      case LC_DOCUMENT_DELETE_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export const proformaInvoiceEscalateReducer = (state = {}, action) => {
    switch (action.type) {
      case LC_PROFORMA_INVOICE_ESCALATE_REQUEST:
        return { ...state, loading: true, error: null, success: false }; // Reset error and success states
      case LC_PROFORMA_INVOICE_ESCALATE_SUCCESS:
        return { ...state, loading: false, success: true, response: action.payload, error: null }; // Reset error state
      case LC_PROFORMA_INVOICE_ESCALATE_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload, // The error message is stored here
          success: false, // Reset success state
        };
      case LC_PROFORMA_INVOICE_ESCALATE_RESET:
        return {}; // Reset the entire state
      default:
        return state;
    }
  };
  export const getListPIByStatusReducer = (state = { proformaInvoices: [] }, action) => {
    switch (action.type) {
      case LC_GET_LIST_BY_STATUS_REQUEST:
        return { loading: true, proformaInvoices: [] };
      case LC_GET_LIST_BY_STATUS_SUCCESS:
        return { loading: false, proformaInvoices: action.payload };
      case LC_GET_LIST_BY_STATUS_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };

  export const piNumberListReducer = (state = { piNumbers: [] }, action) => {
    switch (action.type) {
      case PI_NUMBER_LIST_REQUEST:
        return { loading: true, piNumbers: [] };
      case PI_NUMBER_LIST_SUCCESS:
        return { loading: false, piNumbers: action.payload };
      case PI_NUMBER_LIST_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };

  export const piConditionsUpdateReducer = (state = {}, action) => {
    switch (action.type) {
      case PI_CONDITIONS_UPDATE_REQUEST:
        return { loading: true };
      case PI_CONDITIONS_UPDATE_SUCCESS:
        return { loading: false, success: true, data: action.payload };
      case PI_CONDITIONS_UPDATE_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };


  ///report customize area check START
  const initialState = {
    productCategoryName: false,
    functionName: false,
    groupName: false,
    brandName: false,
    countryOfOrigin: false,
    productLevel: false,
    productShelfLife: false,
    productPackSize: false,
  };

  // Load state from localStorage (Optional)
const storedState = localStorage.getItem("customizedCheckboxState");
const persistedState = storedState ? JSON.parse(storedState) : initialState;

export const customizedCheckboxReducer = (state = persistedState, action) => {
  switch (action.type) {
    case UPDATE_CUSTOMIZED_CHECKBOXES:
      return { ...state, ...action.payload };

    case RESET_CUSTOMIZED_CHECKBOXES:
      return initialState;

    default:
      return state;
  }
};
///CEHCK BOX STORE AREA END